import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { ExternalLink, Workflow } from 'lucide-react';

function statusTone(status) {
  const s = String(status || '').toLowerCase();
  if (/(deploy|success|active|running)/.test(s)) return 'border-cp-ok bg-cp-inset text-cp-ok';
  if (/(draft|design)/.test(s)) return 'border-cp-mod bg-cp-inset text-cp-mod';
  if (/(fail|error)/.test(s)) return 'border-red-300 bg-red-50 text-red-800';
  return 'border-cp-line bg-cp-surface text-cp-muted';
}

export default function IntegrationSuiteIflowHeader({ meta }) {
  if (!meta) return null;

  const subtitle = [meta.packageName || meta.packageId, meta.version].filter(Boolean).join(' · ');
  const designerUrl = String(meta.designerUrl || '').trim();

  return (
    <div className="rounded-lg border border-cp-line bg-gradient-to-br from-cp-surface to-cp-inset p-4 shadow-sm">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex min-w-0 items-start gap-3">
          <div className="rounded-md border border-cp-line bg-cp-surface p-2">
            <Workflow className="h-5 w-5 text-cp-indigo" aria-hidden />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-medium uppercase tracking-wide text-cp-muted">Integration flow</p>
            <h3 className="truncate text-base font-semibold text-cp-fg">{meta.iflowName}</h3>
            {subtitle && <p className="mt-0.5 truncate text-xs text-muted-foreground">{subtitle}</p>}
            {meta.iflowId && meta.iflowId !== meta.iflowName && (
              <p className="mt-1 truncate font-mono text-[11px] text-cp-muted">{meta.iflowId}</p>
            )}
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {meta.status && (
            <Badge className={statusTone(meta.status)} variant="outline">
              {meta.status}
            </Badge>
          )}
          {designerUrl && (
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="border-cp-line"
              asChild
            >
              <a href={designerUrl} target="_blank" rel="noopener noreferrer">
                <ExternalLink className="mr-2 h-4 w-4" />
                Open in Integration Suite
              </a>
            </Button>
          )}
        </div>
      </div>
      {meta.endpointUrl && (
        <p className="mt-3 truncate text-xs text-cp-muted">
          Endpoint:{' '}
          <a
            href={meta.endpointUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="font-mono text-cp-indigo hover:underline"
          >
            {meta.endpointUrl}
          </a>
        </p>
      )}
    </div>
  );
}
